import {
  MutationActions,
  QueryKeys,
  queryClient,
  useEntityMutation,
} from "@/api/core";
import { CarouselGroupKeys } from "@/api/hooks/carousels/useCarouselGroups";
import { useApi } from "@/hooks";
import { groupRelationshipSchema } from "@/schemas";
import toast from "@/toast";

import type { ApiError } from "@/types/api";
import type { AxiosError } from "axios";

interface Variables {
  id: string;
}

function useUnsubscribeToGroup() {
  const api = useApi();

  return useEntityMutation({
    globalQueryKey: QueryKeys.groupRelationships.global,
    action: MutationActions.UPDATE,
    schema: groupRelationshipSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/groups/${variables.id}/join`, {
        notify: false,
      }),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: CarouselGroupKeys.groups });
    },
    onError(error: AxiosError<ApiError>) {
      if (error.response?.data?.errors) {
        const message = error.response.data.errors[0].error_message;
        toast.error(message);
      }
    },
  });
}

export { useUnsubscribeToGroup };
